import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox, Modal, Button } from '@ets/design-system';

import { useModalData } from 'App/ModalContext/ModalContext';
import { closeModal } from 'App/ModalContext/utils';

const ExportModal = () => {
  const [includeTasks, setIncludeTasks] = useState(true);

  const modalData = useModalData('ExportModal');
  if (!modalData) {
    return null;
  }

  const { objectName, message, checkboxMessage, onExport } = modalData;

  const close = () => {
    closeModal('ExportModal');
  };

  const handleExport = () => {
    onExport(includeTasks);
    close();
  };

  return (
    <Modal width="62rem" open close={close} testId="export-pdf">
      <Modal.Header>
        <FormattedMessage id={'EXPORT'} values={{ name: objectName }} />
      </Modal.Header>
      <Modal.Body>
        <div>
          <FormattedMessage id={message} values={{ name: objectName }} />
          <Checkbox
            checked={includeTasks}
            onChange={() => setIncludeTasks(!includeTasks)}
            style={{ margin: '2rem 0 1rem 0' }}
            testId="export-pdf-include-tasks"
            size="xs"
          >
            <FormattedMessage id={checkboxMessage} />
          </Checkbox>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="standard" size="m" onClick={close} testId="export-pdf-cancel">
          <FormattedMessage id="global.cancel" />
        </Button>
        <Button
          size="m"
          variant="primary"
          onClick={handleExport}
          style={{ margin: '0 0 0 1rem' }}
          testId="export-pdf-submit"
        >
          <FormattedMessage id="global.export" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExportModal;
